import React, { useState } from 'react'
import AddEventModal from '../../Modal/AddEvent'
import AddCrewModal from '../../Modal/AddCrew';
import CrewCard from '../../Cards/CrewCard/CrewCard';
import { getUserByID, teams } from '../../../data/teams';
import { getEventTimeAgo } from '../../../utils/dateUtils';
import { filterDuplicateShoots } from '../../../utils/shootFilters';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../app/slices/modalSlice';

function DashboardEvents({project, setSelectedEventId})
{ const dispatch = useDispatch()
  
    // Events
    const [localEventId, setLocalEventId] = useState('')
    const activeSetEventId = setSelectedEventId || setLocalEventId

    // Frontend-only deduplication (no Firestore writes/deletes):
    // hide same-calendar-date shoots within 6h of the last kept shoot.
    const visibleEvents = filterDuplicateShoots(project.events || [], 'asc');

  return (
    <>
    <div className="section shoots">

      <div className="headings">
        <div className="heading-shoots heading-section">
          
            <h3 className='heading '>Shoots</h3>
          {project.payments?.length>=0&&<div className="new-shoot button tertiary l2 outline icon new"
          onClick={ ()=>{
              dispatch(openModal('createEvent'))
            }
            }>New</div>}
          </div>
        {/* s */}
      </div>
      
      <div className="shoot-list">
          <div  className="event-container">
            <div className="shoot">
        {/* loop events from project (deduplicated client-side) */}
        {
          (visibleEvents?.length > 0 && visibleEvents?.length !== undefined)
            && visibleEvents
            .map((event) => (
                <div key={event.id} className="time">
                  <div className="status large">
                    <div className="signal"></div>
                  </div>
                  <div className="date">
                    <h1>{ new Date(event.date).getDate() }</h1>
                    <h5>{ new Date(event.date).toLocaleString('default', { month: 'short' })}
                    </h5>
                  </div>
                  <p className="in-ago-event-days">{getEventTimeAgo(event.date)}</p>
                  <p className='event-type-label'>{event.type}</p>   
                  <p>{ new Date(event.date).toLocaleTimeString('default', {
                    hour: 'numeric', // Use numeric hour (e.g., 5)
                    minute: '2-digit', // Use two-digit minutes (e.g., 30)
                    hour12: true, // Use 12-hour format (e.g., AM/PM)
                  })}</p>
                  <p className='location'>{event.location}</p>
                </div>
          ))
        }

{
          visibleEvents.length===0 &&
          <div className="shoot new"
            onClick={()=>dispatch(openModal('createEvent'))}
          >
            <div className="time  ">
                <div className="signal status"></div>
                <div className="icon"></div>
                <div className="button primary outline">Add Shoot</div>
          </div>
        </div>}
            </div>
            
          </div>

          {/* <div className="crew">
              {
                event.crews&&event.crews.map((crew) => (
                  crew.role !== 'assistant' &&
                  <CrewCard key={crew.assigne} user={getUserByID(crew.assigne)} role={crew.role}/>
                ))
              }
              <div className="assistants">
                {
                event.crews&&event.crews.map((crew) => (
                  crew.role == 'assistant' &&
                  <CrewCard key={crew.assigne} user={getUserByID(crew.assigne)} role={crew.role}/>
                ))
              }
                <div className="assistant-card new-crew box"
                onClick={ ()=>{
                  activeSetEventId(event.id)
                  dispatch(openModal('addCrew'))
                }
                }>
                  <p>Crew</p>
                </div>
              </div>
            </div> */}

        
        
      </div>
      
      
      
    </div>

      
      </>
  )
}

export default DashboardEvents
// Line Complexity  1.0 -> 